import(/* webpackMode: "eager" */ "/opt/render/project/src/app/blog/blockchain/cryptocurrency-blockchain-trends-2025/page.jsx");
